import './Notifications.css';
import NotificationsList from './NotificationsList';

function NotificationModal({
  notifications,
  setNotificationsFetchCalls,
  refreshNotifications,
  isFetching,
  totalPages,
  page,
  total,
}) {
  return (
    <div>
      <div className="notifications-modal-title">Obavijesti</div>

      <div className="notifications-modal-title-border"></div>

      <NotificationsList
        notifications={notifications}
        isFetching={isFetching}
      />

      <div
        className="notifications-modal-show-more"
        onClick={() => {
          if (page < totalPages) {
            setNotificationsFetchCalls((prevValue) => prevValue + 1);
            refreshNotifications();
          }
        }}
        style={{ cursor: page < totalPages ? 'pointer' : 'default' }}
      >
        {total === 0
          ? 'Nema obavijesti'
          : page < totalPages
          ? 'Prikaži više'
          : 'Prikazane su sve obavijesti'}
      </div>
    </div>
  );
}

export default NotificationModal;
